import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { PageFaq } from "../../service/page/page";
import { PageService } from "../../service/page/page.service";

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  providers: [PageService]
})
export class FaqComponent implements OnInit {
  location: string;
  search: string = '';
  id: number;
  category: string = 'all';
  queryParams: any = {};

  allFaqs: PageFaq[] = [];
  faqs = [];

  selectedIndex: number;

  constructor(private pageService: PageService, private route: ActivatedRoute, private router: Router) {
    this.location = router.url.split('/')[1]

    let obsComb = Observable.combineLatest(this.route.params, this.route.queryParams,
      (params, qparams) => ({ params, qparams }));

    obsComb.subscribe(async ({ params, qparams }) => {
      this.category = params['category'];
      this.search = qparams['search'] ? qparams['search'] : '';
      this.queryParams = {}
      let allFaq = [];

      if (this.search) this.queryParams.search = this.search
      this.id = qparams.id ? qparams.id : null;

      const createLinks = (text: string): string => {
        const urlRegex = /((https?:\/\/)[^\s^)]+)/g;

        return text.replace(urlRegex, (url: string) => {
          return `<a href="${url}" target="_blank">${url}</a>`;
        });
      };

      let categories = await this.pageService.getFaqCategory(this.location);
      this.allFaqs = await Promise.all(categories.map(async (item) => {
        let faqs = await this.initFaq(item.id);
        faqs = faqs.map(faq => { faq.answer = createLinks(faq.answer); return faq; });
        faqs = this.search ? faqs.filter(({ title, answer }) => title.concat(answer).includes(this.search)) : faqs;
        allFaq = allFaq.concat(faqs);

        return {
          id: item.id,
          category: item.name,
          faqs,
        }
      }));

      this.allFaqs.unshift({
        id: 'all',
        category: '전체',
        faqs: allFaq,
      })

      this.onFilter();
    });
  }

  ngOnInit() { }

  ngAfterContentInit() {
    if (this.id) {
      setTimeout(() => {
        document.getElementById(this.id.toString()).scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }, 800);
    }
  }

  async initFaq(id) {
    return await this.pageService.getFaq(id)
  }

  onFilter() {
    let result = this.allFaqs.filter(faq => this.category == faq.id);
    this.faqs = result ? result[0].faqs : [];
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(`${url}?${this.search ? `&search=${this.search}` : ''}`);
  }

  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  onSelect(index: number) {
    this.id = null;
    this.selectedIndex = (this.selectedIndex == index) ? null : index;
  }

  onCopyLink(url: string) {
    var dumTA = document.createElement("input");
    document.body.appendChild(dumTA);
    dumTA.value = `${window.location.toString().split('?')[0]}?id=${url}`;
    dumTA.select();
    document.execCommand("copy");
    dumTA.remove();
    alert('복사되었습니다.')
  }
}



// WEBPACK FOOTER //
// ./src/app/space/faq/faq.component.ts